import React, {useState} from "react";
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

function ValuationContainer({valuations}) {
    window.addEventListener('selectstart', function(e){ e.preventDefault(); });

    const [index, setIndex] = useState(0);

    const next = function() {
        if(index > 0) {
            setIndex(index-1);
        }
    }

    const previous = function() {
        if(index + 2 < valuations?.length) {
            setIndex(index+1);
        }
    }

    if(typeof valuations === 'string') {
        valuations = valuations.split(",").reverse();
    }
    return (
        <span className="float-right text-right d-flex valuation-container">
            {index + 3 < valuations?.length &&
                <FontAwesomeIcon onClick={previous} className="link" style={{paddingTop: '5px'}} icon={faChevronLeft}/>
            }
            {valuations && valuations[index+2] !== undefined &&
                <Valuation valuation={valuations[index+2]}/>
            }
            {valuations && valuations[index+1] !== undefined &&
                <Valuation valuation={valuations[index+1]}/>
            }
            {valuations && valuations[index] !== undefined &&
                <Valuation valuation={valuations[index]}/>
            }
            {index !== 0 && <FontAwesomeIcon onClick={next} className="link" style={{paddingTop: '5px'}} icon={faChevronRight}/>}
            {index === 0 && <div style={{minWidth: '10px'}}></div>}
        </span>
    )
}

export default function Valuation({valuation, isPlayerList=false, isPlaying=false}) {
    let classes = "squad-player-valuation-number"
    if(valuation < 0) {
        classes += " squad-player-valuation-number-negative"
    }
    else if(valuation > 0) {
        classes += " squad-player-valuation-number-positive"
    }
    else if(valuation === ",") {
        valuation = null;
    }
    if(isPlayerList) {
        classes += ' valuation-is-player-list'
    }
    if(isPlaying) {
        classes += ' now_playing'
    }
    return (
        <div className={classes}>
            {!isNaN(parseInt(valuation)) ? valuation : "-"}
        </div>
    )
}

export {ValuationContainer}